<script>
    import Button from './button.svelte';
    export let togglerclr = 'black';
    export let bgclr = 'transparent';
    let sideMenu;
    let sideMenuInner;
    let close;
    let open;
    let line;
    let HeadingClass = 'heading1';
    const heading = [
        {
            heading: 'Gamers',
            top: '14.7vh',
            link: '/gamers',
        },
        {
            heading: 'Artists & Musicians',
            top: '20.9vh',
            link: '/artist',
        },
        {
            heading: 'Storytellers',
            top: '27vh',
            link: '/story',
        },
        {
            heading: 'Performers',
            top: '33vh',
            link: '/performance',
        },
    ];
    const subHeading = [
        {
            text: 'Technical Creators',
            link: '/Create',
        },
        {
            text: 'Advertisers',
            link: '/AdvertPage',
        },
        {
            text: 'Investors',
            link: '/InvestPage',
        },
        {
            text: 'Team',
            link: '/Team',
        },
    ];
    let mainDiv;
    let text;
    let redDiv;
    let imgClr = 'black';
    let backclr = 'white';
    export let borderclr =' black';
    export let textclr =' black';
    export let textClrAfter ='white';
    export let bgClrAfter ='transparent';
</script>

<nav>
    <div class="mainDiv">
        <div
            class="logo"
            on:click={() => {
                location.href = '/';
            }}
        >
            <img src="/images/opus_logo.svg" alt="" />
        </div>

        <div style="display:flex ;margin-right:-4.95vw;align-items: center;">
            <a href='https://blog.opus.ai' target="_blank">
            <div
                class="third-btn"
                bind:this={mainDiv}
                on:mouseenter={() => {
                    mainDiv.style.background = 'black';
                    mainDiv.style.width = 'max(22.593vh, 122px)';
                    text.style.color = 'white';
                    redDiv.style.width = 'max(2.500vh , 23.5px)';
                    redDiv.style.height = 'max(2.500vh , 23.5px)';
                    redDiv.style.fontSize = 'max(1.111vh , 6px)';
                    redDiv.style.lineHeight = '1.2vw';
                    redDiv.style.right = '-2.1vw';
                    redDiv.style.top = '-0.8vw';
                    imgClr = 'white';
                    backclr = 'black';
                    mainDiv.style.transitionDuration = '1s';
                    redDiv.style.transitionDuration = '1s';
                    text.style.transitionDuration = '2s';
                }}
                on:mouseleave={() => {
                    mainDiv.style.background = 'none';
                    text.style.color = 'transparent';
                    redDiv.style.width = 'max(1.481vh, 8px)';
                    redDiv.style.height = 'max(1.481vh, 8px)';
                    redDiv.style.fontSize = 'max(0.926vh, 5px)';
                    redDiv.style.lineHeight = '0.7vw';
                    redDiv.style.right = '-0.4vw';
                    redDiv.style.top = '-0.5vw';
                    imgClr = 'black';
                    backclr = 'white';
                    mainDiv.style.width = '0vw';
                }}
            >
                <p bind:this={text}>Explore our Blog</p>
                <div style="display: flex;position:absolute;right:1.5vw;">
                    <div
                        style="background-color:{backclr};border-radius:1vh;width:max(2.315vh, 12.5px);height:max(2.500vh , 13.5px);"
                    >
                        <svg
                            width="100%"
                            height="100%"
                            viewBox="0 0 25 27"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M1.39411 0.124344C0.914385 0.291157 0.304399 0.899088 0.137617 1.37671C0.0170841 1.72174 0.000566602 3.18308 0.000566602 13.4977C0.000566602 26.6018 -0.0430931 25.717 0.636088 26.3795C1.3117 27.0388 0.561715 26.9996 12.5003 26.9996C22.0302 26.9996 23.2275 26.9846 23.5991 26.8611C24.1409 26.6809 24.7594 26.0255 24.8994 25.483C24.9715 25.2035 25 21.7936 25 13.4311C25 3.06374 24.9845 1.72453 24.8598 1.36782C24.6862 0.870517 24.0051 0.223125 23.5163 0.0907196C23.2771 0.0259107 19.8507 -0.00213825 12.4556 0.000126574C3.55299 0.00291405 1.68285 0.0239073 1.39411 0.124344ZM14.695 4.3026C14.8645 4.52891 14.8551 4.86767 14.6739 5.06306C14.5336 5.21428 14.232 5.22238 8.73653 5.22238C3.06594 5.22238 2.94327 5.21881 2.76836 5.04816C2.48274 4.7695 2.58658 4.33135 2.97505 4.17673C3.08389 4.13335 5.69062 4.10669 8.86921 4.11627C14.3968 4.133 14.5721 4.13857 14.695 4.3026ZM20.3394 5.60609C20.8629 5.87186 21.0214 6.14181 21.057 6.82823L21.0899 7.46482L20.7905 7.5102C20.6259 7.53512 19.7379 7.56125 18.8171 7.56822L17.143 7.58102V7.0825C17.143 6.38685 17.3977 5.89983 17.8842 5.66489C18.1905 5.51698 18.4274 5.48379 19.1787 5.48379C19.7947 5.48371 20.1779 5.52412 20.3394 5.60609ZM21.0208 9.81736C20.9988 10.5719 20.9563 12.7061 20.9265 14.5598L20.8722 17.9303L19.0746 17.9571C18.0859 17.9718 17.2468 17.9717 17.21 17.9569C17.1732 17.9421 17.143 15.8169 17.143 13.2342V8.53843L18.1028 8.51039C18.6307 8.49497 19.5123 8.47406 20.0618 8.46387L21.061 8.4454L21.0208 9.81736ZM14.695 9.96467C14.8645 10.191 14.8551 10.5297 14.6739 10.7251C14.5336 10.8763 14.2307 10.8844 8.69394 10.8844H2.86175L2.71095 10.66C2.52167 10.378 2.62738 10.0229 2.94845 9.86301C3.12201 9.77651 4.40672 9.75717 8.86921 9.77407C14.3942 9.79489 14.5721 9.80073 14.695 9.96467ZM14.4346 15.5067C14.5718 15.5576 14.7144 15.6457 14.7515 15.7027C14.8669 15.8798 14.8283 16.2207 14.6739 16.3872C14.5336 16.5384 14.2307 16.5465 8.69394 16.5465H2.86175L2.71095 16.322C2.52158 16.0399 2.62756 15.6845 2.94845 15.5261C3.24031 15.382 14.0492 15.3637 14.4346 15.5067ZM20.8037 18.8909C20.8037 18.9347 20.4722 19.6841 20.0671 20.5562C19.0017 22.85 18.8755 22.8575 17.9791 20.6817C17.6637 19.9166 17.3828 19.2033 17.3546 19.0968C17.3037 18.904 17.3092 18.9031 18.6294 18.8765C19.3588 18.8619 20.1463 18.8412 20.3796 18.8306C20.6129 18.82 20.8037 18.8471 20.8037 18.8909ZM14.4359 21.1533C14.7895 21.1866 14.9419 21.7603 14.6739 22.0493C14.5336 22.2005 14.2307 22.2086 8.69394 22.2086H2.86175L2.71095 21.9841C2.52828 21.7121 2.62488 21.3472 2.91711 21.205C3.04657 21.142 4.90367 21.1174 8.71903 21.1279C11.8054 21.1364 14.3779 21.1479 14.4359 21.1533Z"
                                fill={imgClr}
                            />
                        </svg>
                    </div>
                    <div bind:this={redDiv} class="red-div"><span>1</span></div>
                </div>
            </div>
            </a>
            <div
                class="btn"
                on:click={() => {
                    location.href = '/demo';
                }}
                style="
            margin-right: 3.438vw;    position: relative;
            z-index: 0;cursor:pointer;"
            >
                <Button
                    {bgclr}
                    border="0.093vh solid {borderclr}"
                    color={textclr}
                    bgclrHover={bgClrAfter}
                    colorHover={textClrAfter}
                />
            </div>
            <div
                class="icon"
                bind:this={open}
                on:click={() => {
                    sideMenu.style.top = '0vw';
                    sideMenu.style.left = '-1vw';
                    sideMenu.style.transitionDuration = '1s';
                    sideMenuInner.style.top = '0vw';
                    sideMenuInner.style.left = '59.7vw';
                    sideMenuInner.style.transitionDuration = '1s';
                    close.style.visibility = 'visible';
                    close.style.opacity = '100%';
                    open.style.opacity = '0%';
                    open.style.visibility = 'hidden';
                    close.style.marginTop = ' 0vw';
                    close.style.marginRight = ' 6.5vw';
                }}
            >
                <svg
                    width="2.076vw"
                    height="2.348vw"
                    viewBox="0 0 40 31"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <line
                        x1="7.47363"
                        y1="2.5"
                        x2="37.4998"
                        y2="2.5"
                        stroke={togglerclr}
                        stroke-width="5"
                        stroke-linecap="round"
                    />
                    <line
                        x1="18.3438"
                        y1="15.1821"
                        x2="37.4997"
                        y2="15.1821"
                        stroke={togglerclr}
                        stroke-width="5"
                        stroke-linecap="round"
                    />
                    <line
                        x1="2.64258"
                        y1="27.8638"
                        x2="37.5"
                        y2="27.8638"
                        stroke={togglerclr}
                        stroke-width="5"
                        stroke-linecap="round"
                    />
                </svg>
            </div>
            <div
                class="crossIcon"
                bind:this={close}
                on:click={() => {
                    sideMenu.style.left = '0vw';
                    sideMenu.style.transitionDuration = '1s';
                    sideMenu.style.top = '-100vh';
                    sideMenuInner.style.left = '60vw';
                    sideMenuInner.style.transitionDuration = '1s';
                    sideMenuInner.style.top = '-100vh';
                    close.style.visibility = 'hidden';
                    close.style.opacity = '0%';
                    open.style.opacity = '100%';
                    open.style.visibility = 'visible';
                    open.style.marginRight = ' -4.5vw';
                }}
            >
                <img
                    src="/images/navbar/cross.svg"
                    alt=""
                    width="100%"
                    height="100%"
                />
            </div>
        </div>
    </div>

    <div class="menu_back" bind:this={sideMenu}>
        <div class="menu_Section" bind:this={sideMenuInner}>
            <div class="line" bind:this={line} />
            <div class="Text">
                {#each heading as data, i}
                    <h3
                        on:click={() => {
                            location.href = data.link;
                        }}
                        class={HeadingClass}
                        on:mouseenter={() => {
                            line.style.opacity = '1';
                            line.style.top = data.top;
                            HeadingClass = 'heading2';
                        }}
                        on:mouseleave={() => {
                            line.style.opacity = '0';
                            line.style.top = '4.4vw';
                            HeadingClass = 'heading1';
                        }}
                    >
                        {data.heading}
                    </h3>
                {/each}
                <!-- <div
                    class="btn"
                    style="
                position: relative;
                z-index: 0;
                padding: 6.094vw 0;"
                >
                    <button class="join-btn"> Join Community </button>
                </div> -->
                <hr class="hrcss" />
                <div style="margin-top: 3.241vh;">
                    {#each subHeading as data}
                        <p
                            on:click={() => {
                                location.href = data.link;
                            }}
                        >
                            {data.text}
                        </p>
                    {/each}
                    <a href='https://blog.opus.ai' target="_blank">
                    <p>
                        Blogs
                    </p>
                </a> 
                </div>
                <div class="social_links">
                    <a href="https://twitter.com/OpusAIInc" target="_blank">
                        <svg class="social1"  viewBox="0 0 26 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.17934 20C17.9882 20 23.3548 12.3046 23.3548 5.63322C23.3548 5.41688 23.3497 5.19574 23.3396 4.9794C24.3835 4.26466 25.2845 3.37935 26 2.36507C25.0277 2.7746 23.9954 3.04206 22.9384 3.15831C24.0514 2.52672 24.8847 1.53451 25.284 0.365627C24.2369 0.953083 23.0919 1.36748 21.8979 1.59106C21.0934 0.78181 20.0297 0.24599 18.8713 0.0664421C17.7129 -0.113105 16.5243 0.0736207 15.4892 0.597751C14.4541 1.12188 13.6303 1.95422 13.145 2.96609C12.6597 3.97796 12.54 5.11299 12.8045 6.1957C10.6844 6.09498 8.61026 5.57358 6.71665 4.6653C4.82303 3.75702 3.15217 2.48213 1.81238 0.923299C1.13143 2.03477 0.923061 3.35001 1.22962 4.6017C1.53617 5.85339 2.33465 6.94762 3.46277 7.66199C2.61585 7.63654 1.78747 7.42066 1.04609 7.03221V7.09471C1.04534 8.26111 1.47127 9.39178 2.2515 10.2945C3.03173 11.1972 4.1181 11.8163 5.32594 12.0464C4.54139 12.2497 3.71798 12.2793 2.91941 12.133C3.26024 13.1361 3.92337 14.0135 4.81625 14.6426C5.70913 15.2718 6.78721 15.6213 7.90004 15.6425C6.01079 17.0474 3.67702 17.8095 1.27461 17.8058C0.848561 17.8052 0.422932 17.7805 0 17.7318C2.44059 19.2141 5.27966 20.0014 8.17934 20Z" fill="black"/>
                        </svg>
                    </a>
                </div>    
            </div>
        </div>
    </div>
</nav>

<style>
    .social_links {
        width: max(4vh, 21.6px);
        text-align: center;
        cursor: pointer;
        margin-top: 1.5vw;
    }
    .social1 {
        width: 1.8vw;
        height: 1.852vw; 
    }
    .third-btn {
        margin-right: max(4.63vh, 25px);
        width: 0vw;
        height: max(3.704vh, 20px);
        display: flex;
        justify-content: space-around;
        align-items: center;
        position: relative;
        cursor: pointer;
    }
    .third-btn p {
        font-size: max(1.296vh, 7px);
        font-weight: 700;
        color: transparent;
        margin-right: 2.5vw;
        position: absolute;
        left: 1vw;
        width: 7vw;
    }
    .red-div {
        color: white;
        font-size: max(0.926vh, 5px);
        font-weight: 700;
        width: max(1.481vh, 8px);
        height: max(1.481vh, 8px);
        background-color: red;
        border-radius: 100%;
        position: absolute;
        right: -0.4vw;
        top: -0.5vw;
        text-align: center;
        border-radius: 100%;
        box-sizing: border-box;
        padding-right: 0.1vw;
    }
    .line {
        border-left: 0.3vw solid rgb(0, 0, 0);
        height: 1.3vw;
        position: relative;
        top: 6vh;
        left: 5vh;
        width: 0.1vw;
        opacity: 0;
        transition-duration: 1s;
    }
    nav {
        font-family: "Orbitron";
    }
    .logo {
        width: max(16.481vh, 89px);
        height: max(6.852vh, 37px);
        background-color: black;
        border-radius: 0 0.926vh 0.926vh 0;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        z-index: 2;
    }
    .mainDiv {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: max(3.704vh, 20px);
    }
    .logo img {
        width: max(9.537vh, 51.5px);
    }
    .icon {
        padding-right: 2.604vw;
        visibility: visible;
        opacity: 100%;
        transition-duration: 1s;
        cursor: pointer;
    }
    .crossIcon {
        width: max(3.5vh, 14.5px);
        height: max(3.5vh, 14.5px);
        float: right;
        margin-right: 6.63vh;
        visibility: hidden;
        opacity: 0%;
        z-index: 5;
        transition-duration: 1s;
        margin-top: -2.3vw;
        cursor: pointer;
    }
    .menu_back {
        background-image: url(/images/navbarpic.png);
        background-size: cover;
        background-position: center;
        position: absolute;
        height: 100vh;
        width: 60.75vw;
        left: 0vh;
        top: -100vh;
        transition-duration: 1s;
        z-index: 1;
    }
    .menu_Section {
        position: fixed;
        height: 100vh;
        width: max(40.365vw, 387.5px);
        background-color: #ffffff;
        z-index: 3;
        right: 0vw;
        cursor: pointer;
        left: 60vw;
        top: -100vh;
    }

    p,
    h3 {
        margin: 0;
    }
    .Text {
        margin: 11.389vh 10.185vh 0vw;
    }
    .heading2 {
        font-weight: 400;
        font-size: 2.15vw;
        line-height: max(4.63vh, 25px);
        color: grey;
        padding-bottom: 1.389vh;
        transition-duration: 1s;
    }
    .heading1 {
        font-weight: 400;
        font-size: 2.15vw;
        line-height: max(4.63vh, 25px);
        color: black;
        padding-bottom: 1.389vh;
        transition-duration: 1s;
    }
    .heading2:hover {
        font-weight: 900;
        color: #000000;
        transition-duration: 1s;
    }
    .heading1::first-letter {
        font-weight: 900;
    }
    .Text p {
        font-weight: 600;
        font-size: max(1.852vh, 10px);
        line-height: max(2.315vh, 12.5px);
        color: black;
        padding-bottom: 0.926vh;
    }
    .hrcss {
        width: max(56.296vh, 304px);
        border: 0.02vw solid #000000;
        margin: 0;
        background-color: black;
    }
    .join-btn {
        width: 8.958vw;
        height: 2.083vw;
        background: transparent;
        font-size: 0.729vw;
        font-weight: 700;
        border: 0.052vw solid black;
        font-family: "Orbitron";
        cursor: pointer;
        transition-duration: 1.3s;
    }
    .join-btn:hover {
        background-color: black;
        color: white;
    }
</style>
